import type { ProcessTraceStatus } from "@playbookai/widget-schemas";
import type { CategoricalTint } from "../../lib/tints.js";
import type { StatusTone } from "../../lib/tones.js";

export const PROCESS_TRACE_STATUS_OPTIONS: ReadonlyArray<{
  readonly value: ProcessTraceStatus;
  readonly label: string;
}> = [
  { value: "unknown", label: "Not established" },
  { value: "observed", label: "Observed" },
  { value: "supported", label: "Supported" },
  { value: "needs_validation", label: "Needs validation" },
  { value: "validated", label: "Validated" },
];

export function processTraceStatusLabel(status: ProcessTraceStatus): string {
  return (
    PROCESS_TRACE_STATUS_OPTIONS.find((option) => option.value === status)
      ?.label ?? "Not established"
  );
}

/** A status pill's colour: a semantic tone, or categorical tint 7 for the
 *  decorative purple of "supported" (look row OK-15). */
export type ProcessTraceStatusColour =
  | { readonly tone: StatusTone; readonly tint?: undefined }
  | { readonly tint: CategoricalTint; readonly tone?: undefined };

const PROCESS_TRACE_STATUS_COLOUR: Record<
  ProcessTraceStatus,
  ProcessTraceStatusColour
> = {
  observed: { tone: "info" },
  supported: { tint: 7 },
  needs_validation: { tone: "watch" },
  validated: { tone: "healthy" },
  unknown: { tone: "neutral" },
};

export function processTraceStatusColour(
  status: ProcessTraceStatus,
): ProcessTraceStatusColour {
  return PROCESS_TRACE_STATUS_COLOUR[status];
}
